var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.033 11.2916C14.683 11.6332 14.483 12.1249 14.533 12.6499C14.608 13.5499 15.433 14.2082 16.333 14.2082H17.9163V15.1999C17.9163 16.9249 16.508 18.3333 14.783 18.3333H5.21634C3.49134 18.3333 2.08301 16.9249 2.08301 15.1999V9.59159C2.08301 7.86659 3.49134 6.45825 5.21634 6.45825H14.783C16.508 6.45825 17.9163 7.86659 17.9163 9.59159V10.7916H16.233C15.7663 10.7916 15.3413 10.9749 15.033 11.2916Z",
    stroke: "#F0F8FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08301 10.3416V6.5333C2.08301 5.54163 2.69134 4.65826 3.61634 4.30826L10.233 1.80826C11.2663 1.41659 12.3747 2.18329 12.3747 3.29162V6.45828",
    stroke: "#F0F8FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7987 11.6417V13.3584C18.7987 13.8168 18.432 14.1917 17.9653 14.2084H16.332C15.432 14.2084 14.607 13.5501 14.532 12.6501C14.482 12.1251 14.682 11.6334 15.032 11.2917C15.3404 10.9751 15.7653 10.7917 16.232 10.7917H17.9653C18.432 10.8084 18.7987 11.1834 18.7987 11.6417Z",
    stroke: "#F0F8FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 10H11.6663",
    stroke: "#F0F8FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.df45d33289a4a72306688553b81c828a.svg";
export { ForwardRef as ReactComponent };